import {
    GET_SOURCE_COMBINATION_LIST,
    GET_SOURCE_COMBINATION_LIST_LOADING,
    GET_SOURCE_COMBINATION_LIST_FAILD,
} from "../type/type";

const initialState = {
    allLeadsData: {
        docs: [],
        totalDocs: 0,
        limit: 0,
        page: 0,
        totalPages: 0,
        pagingCounter: 0,
        hasPrevPage: false,
        hasNextPage: false,
        prevPage: null,
        nextPage: null,
    },
    allLeadsLoading: true,
    loading: false,
};

const sourceCombinationReducers = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_SOURCE_COMBINATION_LIST_LOADING:
            return { ...state, loading: true };
        case GET_SOURCE_COMBINATION_LIST:
            return {
                ...state,
                allLeadsData: {
                    ...state.allLeadsData, // Keep existing structure
                    ...payload, // Update with new API response data
                    page: payload.page || state.allLeadsData.page, // Ensure the page updates correctly
                },
                allLeadsLoading: false,
                loading: false
            };
        case GET_SOURCE_COMBINATION_LIST_FAILD:
            return {
                ...state,
                loading: false,
                allLeadsLoading: false,
            };
        default:
            return state;
    }
};

export default sourceCombinationReducers;